// Actions
import { SET_ISSUES_BY_CUSTOMER } from "./issues.actions";
import { SET_SALES_SELECTED_MODULE } from "./issues.actions";
import { SET_SALES_ORDERBY_VALUE } from "./issues.actions";
import { SET_SALES_SELECTED_BOX } from "./issues.actions";
import { SET_SALES_VIEW_TYPE } from "./issues.actions";
import { RESET_SALES_ISSUES } from "./issues.actions";
// Helpers
import { resetSalesIssuesState } from "./issues.reducer.helpers";
import { getInitialPaginationData } from "util/pagination";
import { setPage } from "util/redux.utils";
// Types
import { ViewTypes } from "types/issues.types";
import { OrdersState as State } from "./issues.types";
import { SetIssuesByCustomerAction } from "./issues.types";
import { SalesIssuesActions as Actions } from "./issues.types";

const initialState: State = {
  selectedModuleId: "",
  orderBy: "",
  selectedBoxId: "",
  viewType: ViewTypes.ROWS,
  issuesByCustomer: getInitialPaginationData()
};

const reducer = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SET_SALES_SELECTED_MODULE:
      return { ...state, selectedModuleId: action.payload };
    case SET_SALES_ORDERBY_VALUE:
      return { ...state, orderBy: action.payload };
    case SET_SALES_SELECTED_BOX:
      return { ...state, selectedBoxId: action.payload };
    case SET_SALES_VIEW_TYPE:
      return { ...state, viewType: action.payload };
    case SET_ISSUES_BY_CUSTOMER:
      return setIssuesByCustomer(state, action.payload);
    case RESET_SALES_ISSUES:
      return resetSalesIssues(state);
    default:
      return state;
  }
};

const setIssuesByCustomer = (
  state: State,
  payload: SetIssuesByCustomerAction["payload"]
): State => {
  const { issuesByCustomer } = payload;
  const oldIssues = { ...state.issuesByCustomer };
  const newIssues = setPage(oldIssues, issuesByCustomer);
  return { ...state, issuesByCustomer: newIssues };
};

const resetSalesIssues = (state: State): State => {
  return {
    ...state,
    ...resetSalesIssuesState
  };
};

export default reducer;
